var AlgoliaFilterOperator = /* @__PURE__ */ ((AlgoliaFilterOperator2) => {
  AlgoliaFilterOperator2["OR"] = "OR";
  AlgoliaFilterOperator2["NOT"] = "NOT";
  AlgoliaFilterOperator2["AND"] = "AND";
  AlgoliaFilterOperator2["AND_NOT"] = "AND NOT";
  return AlgoliaFilterOperator2;
})(AlgoliaFilterOperator || {});
const getFilter = (id, value) => {
  const escapedValue = typeof value === "string" && value.includes(" ") ? `'${value}'` : value;
  return `${id}:${escapedValue}`;
};
function createAlgoliaFilters(filterableAttributes, operator, prefix) {
  if (!filterableAttributes.length) {
    return operator || prefix ? "" : [];
  }
  const filters = filterableAttributes.reduce((prev, { id, value }) => {
    if (typeof value === "string") {
      const result = getFilter(id, value);
      prev.push(result);
    }
    if (Array.isArray(value)) {
      const result = value.map((val) => getFilter(id, val)).join(` ${"OR"} `);
      const filterString = value.length > 1 ? `(${result})` : result;
      prev.push(filterString);
    }
    return prev;
  }, []);
  if (operator || prefix) {
    return `${prefix ? `${prefix} ` : ""}${filters.join(` ${operator} `)}`;
  } else {
    return filters;
  }
}
export {
  AlgoliaFilterOperator,
  createAlgoliaFilters
};
//# sourceMappingURL=create-algolia-filters.js.map
